import {
  initializeFirebase,
  getFirebaseAnalytics,
  logEvent,
  getString
} from './javascript-fire-base.js';

const sections = {
  "2.0": [
    "rural-internet-hero",
  ],
  "1.0": [
    "rural-internet-hero-b",
  ],
  "all": [
    "horizontal-green-bar",
    "why-nomad",
    "how-nomad-works",
    "americas-largest-provider",
    "shop-with-confidence",
    "quiz-section",
    "reviews",
    "faq",
    "contact"
  ]
}

async function initializeRuralInternetPageLayout() {
  try {
    const { firebaseRemoteConfig } = await initializeFirebase();

    const activePageVersion = getString(firebaseRemoteConfig, "rural_internet_page_version_2");
    // alert(`Active Page Version: ${activePageVersion}`);
    // const activePageVersion = "1.0"; // Hardcoded for testing purposes

    Object.keys(sections).forEach(version => {
      if (version !== activePageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activePageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return activePageVersion;
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all").sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return latestVersion;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  const activePageVersion = await initializeRuralInternetPageLayout();

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      logEvent(getFirebaseAnalytics(), 'primary_cta_click', {
        source: 'rural_internet_page',
        page_version: activePageVersion
      });
    });
  });
})
